import { filter } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  styled,
  Divider,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Backdrop,
  CircularProgress,
  Select,
  IconButton
} from '@material-ui/core';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker from '@material-ui/lab/DatePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import moment from 'moment';
import RefreshIcon from '@material-ui/icons/Refresh';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useClientContext } from '../../context/client_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const TABLE_HEAD = [
  { id: 'department', label: 'Id', alignRight: true },
  { id: 'tarrifCode', label: 'Date', alignRight: true },
  { id: 'description', label: 'EC #', alignRight: false },
  { id: 'service', label: 'Surname', alignRight: false },
  { id: 'count', label: 'First Name', alignRight: false },
  // { id: 'amount', label: 'ID Number', alignRight: false },
  { id: 'units', label: 'Cell #', alignRight: false },
  { id: 'amountPd', label: 'Reason', alignRight: false },
  { id: 'montrate', label: 'Monthly', alignRight: true },
  { id: 'totdue', label: 'Total Due', alignRight: true },
  { id: 'post', label: 'Now a Member', alignRight: true },
  { id: 'posat', label: 'SSB Created', alignRight: true },
  { id: 'sources', label: 'Source', alignRight: true },
  { id: 'mmm', label: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function WebApplications() {
  const { setRegRefId, getClientByRefId } = useClientContext();
  const m = moment();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [begDate, setBegDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docType, setDocType] = useState('pdf');
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [changeType, setChangeType] = useState('0');
  const [rowsPerPage, setRowsPerPage] = useState(14);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const filename = `ExtraPayments_${moment().format('DD-MMM-YYYY')}.${docType}`;
  const navigate = useNavigate();
  console.log('begDate in useEffect 123', begDate);
  useEffect(() => {
    getWebApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getStatus = (e) => {
    switch (e.status) {
      case 0:
        return 'New';
      case 1:
        return 'Submitted';
      case 2:
        return 'Approved';
      case 3:
        return 'Declined';
      case 4:
        return 'Pending Approved';
      case 5:
        return 'Pending Declined';
      default:
        return 'Unknown';
    }
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  const getWebApplications = () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/client/getWebApplications?begDate=${moment(begDate).format(
        'YYYY-MM-DD'
      )}&endDate=${moment(endDate).format('YYYY-MM-DD')}&dataType=${changeType}`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('returned getWebApplications list', result);
          console.log('returned dddd list', sessionStorage.getItem('dept'));
          if (sessionStorage.getItem('dept') === '5') {
            console.log('came here now');
            setDataList(
              result.result.filter(
                (item) => item.groupId === Number(sessionStorage.getItem('province'))
              )
            );
          } else {
            console.log('came yester now');
            setDataList(result.result);
          }
          // console.log('returned getWebApplications list', result);
          // setDataList(result.result);
          // setLoading(false);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in getWebApplications!: ${error}`, 'error');
        }
      );
  };

  const downloadDocument = () => {
    notifyPopup(`The download functionality has not been completed...`, 'error');
    // setLoading(true);
    // fetch(
    //   `${baseUrl}/api/report/get/WebApplications/${docType}/${moment(begDate).format(
    //     'YYYY-MM-DD'
    //   )}/${moment(endDate).format('YYYY-MM-DD')}/0/0/0/0/0`
    // )
    //   .then((response) => response.blob())
    //   .then(
    //     (blob) => {
    //       const url = window.URL.createObjectURL(new Blob([blob]));
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.setAttribute('download', `${filename}`);
    //       document.body.appendChild(link);
    //       link.click();
    //       link.parentNode.removeChild(link);
    //       setLoading(false);
    //     },
    //     (error) => {
    //       notifyPopup(`Error in Claims by Department!: ${error}`, 'error');
    //     }
    //   );
  };

  const createSsbBulk = async () => {
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(dataList);
    console.log('filtered stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/createSsbBulk`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned SSB Bulk', res);
          setLoading(false);
          notifyPopup(`SSB Bulk Created Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Creating SSB In Bulk!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const handleClientView = async (e) => {
    console.log('e claimId', e.row.refId);
    setRegRefId(e.row.refId);
    await getClientByRefId(e.row.refId);
    openView(e.row.refId);
  };

  const openView = (e) => {
    navigate(`/clientportfolio/updatenew/${e}`);
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={5} sm={2}>
          <Typography component="span" variant="h4" gutterBottom>
            Applications from Web
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl>
            <InputLabel id="selectoc">Member Status</InputLabel>
            <Select
              labelId="selectChangelabel"
              id="changeType"
              value={changeType}
              size="small"
              variant="standard"
              onChange={(e) => {
                setChangeType(e.target.value);
              }}
            >
              <MenuItem value="99">All Applications</MenuItem>
              <MenuItem value="0">New Applications</MenuItem>
              <MenuItem value="1">Submitted to SSB</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={1}>
          <FormControl>
            <InputLabel id="selectDoc">Doc Type</InputLabel>
            <Select
              labelId="selectDoclabel"
              id="docType"
              size="small"
              value={docType}
              onChange={(e) => {
                setDocType(e.target.value);
              }}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="xls">XLS</MenuItem>
              <MenuItem value="doc">WORD</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Start Date"
              // inputFormat="dd/MM/yyyy"
              value={begDate}
              onChange={(e) => {
                setBegDate(e);
              }}
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="End Date"
              // inputFormat="dd/MM/yyyy"
              value={endDate}
              onChange={(e) => {
                setEndDate(e);
              }}
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => getWebApplications()}
          >
            Refresh
          </Button>
        </Grid>
        {/* <Grid item xs={12} sm={1} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => downloadDocument()}
          >
            Export
          </Button>
        </Grid> */}
        <Grid item xs={12} sm={1} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => createSsbBulk()}
          >
            Create SSB All
          </Button>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, margin: 10 }} variant="middle" />

      <Card>
        {/* <Scrollbar> */}
        <TableContainer sx={{ minWidth: 800 }}>
          <Table size="small" aria-label="a dense table">
            <ClientListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {filteredUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  /* eslint-disable camelcase */
                  const {
                    ecNumber,
                    surname,
                    firstName,
                    source,
                    cellNumber,
                    stn,
                    dpt,
                    reason,
                    monthlyRate,
                    totalDue,
                    refId,
                    createdDate,
                    posted,
                    status
                  } = row;
                  const isItemSelected = selected.indexOf(refId) !== -1;

                  return (
                    <StyledTableRow
                      hover
                      key={refId}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell padding="checkbox" />

                      <TableCell align="right">{refId}</TableCell>
                      <TableCell align="right">
                        {moment(createdDate).isValid()
                          ? moment(createdDate).format('YYYY-MM-DD')
                          : ''}
                      </TableCell>
                      <TableCell align="left">{ecNumber}</TableCell>
                      <TableCell align="left">{surname}</TableCell>
                      <TableCell align="left">{firstName}</TableCell>
                      {/* <TableCell align="left">{idNumber}</TableCell> */}
                      <TableCell align="left">{cellNumber}</TableCell>
                      <TableCell align="left">{reason}</TableCell>
                      <TableCell align="right">{monthlyRate.toFixed(2)}</TableCell>
                      <TableCell align="right">{totalDue.toFixed(2)}</TableCell>
                      <TableCell align="right">{posted ? 'Yes' : 'No'}</TableCell>
                      <TableCell align="right">{getStatus({ status })}</TableCell>
                      <TableCell align="left">{source}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => handleClientView({ row })}>
                          <VisibilityIcon sx={{ color: '#03a9f4' }} />
                        </IconButton>
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isListEmpty && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
        {/* </Scrollbar> */}

        <TablePagination
          sx={{
            backgroundColor: 'black',
            color: 'white',
            size: 'small'
          }}
          rowsPerPageOptions={[14, 28, 42]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
